
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1>Administration</h1>
    </div>
    <!-- Show user data when logged in -->
    <div class="row">
      <div class="col-md-12">
        <div class="media">
          <div class="media-body">
            <div>{{ personnage.nom }}</div>

            <h2>Personnage</h2>
            <form [formGroup]="characterSheetForm" (ngSubmit)="changePersonnage()">
              <div class="row">
                <div class="form-group col-3">
                  <label for="Nom">Nom :</label>
                  <input type="text" formControlName="Nom" class="form-control">
                </div>
                <div class="form-group col-2">
                  <label for="Legion">Légion : </label>
                  <select formControlName="Legion" class="form-control">
                    <option [ngValue]="null" disabled>Choisir Légion</option>
                    <option *ngFor="let legion of legions.values | keyvalue" [ngValue]="legion.key">{{legion.value}}</option>
                  </select>
                </div>    
                <div class="form-group col-2">
                  <label for="Astre1">Premier Astre : </label>
                  <select formControlName="Astre1" class="form-control">
                    <option [ngValue]="null" disabled>Choisir Premier Astre</option>
                    <option *ngFor="let astre of astres.values | keyvalue" [ngValue]="astre.key">{{astre.value}}</option>
                  </select>
                </div>    
                <div class="form-group col-2" >
                  <label for="Astre2">Second Astre : </label>
                  <select formControlName="Astre2" class="form-control">
                    <option [ngValue]="null">Aucun second Astre</option>
                    <option *ngFor="let astre of astres.values | keyvalue" [ngValue]="astre.key">{{astre.value}}</option>
                  </select>
                </div>
                <div class="form-group col-2">
                  <label for="CrimsonDisponible">CrimsonDisponible :</label>
                  <input type="text" formControlName="CrimsonDisponible" class="form-control">
                </div>
                <div class="form-group col-3">
                  <label for="NotePublic">NotePublic :</label>
                  <textarea formControlName="NotePublic" class="form-control"></textarea>
                </div>
                <div class="form-group col-2">
                  <label for="AchatDisponible">AchatDisponible :</label>
                  <input type="text" formControlName="AchatDisponible" class="form-control">
                </div>
                <div class="form-group col-2">
                  <label for="AchatSortDisponible">AchatSortDisponible :</label>
                  <input type="text" formControlName="AchatSortDisponible" class="form-control">
                </div>
                <div class="form-group col-2">
                  <label for="AchatSortAchete">AchatSortAchete :</label>
                  <input type="text" formControlName="AchatSortAchete" class="form-control">
                </div>
                <div class="form-group col-2">
                  <label for="NombreGnParticipe">NombreGnParticipe :</label>
                  <input type="text" formControlName="NombreGnParticipe" class="form-control">
                </div>
                <div class="form-group col-4">
                  <label for="BackgroundPersonnalite">BackgroundPersonnalite :</label>
                  <textarea formControlName="BackgroundPersonnalite" class="form-control"></textarea>
                </div>
                <div class="form-group col-4">
                  <label for="BackgroundConcept">BackgroundConcept :</label>
                  <textarea formControlName="BackgroundConcept" class="form-control"></textarea>
                </div>
                <div class="form-group col-4">
                  <label for="BackgroundHistorique">BackgroundHistorique :</label>
                  <textarea formControlName="BackgroundHistorique" class="form-control"></textarea>
                </div>
                <div class="form-group col-4">
                  <label for="BackgroundButCourtTerme">BackgroundButCourtTerme :</label>
                  <textarea formControlName="BackgroundButCourtTerme" class="form-control"></textarea>
                </div>
                <div class="form-group col-4">
                  <label for="BackgroundButMoyenTerme">BackgroundButMoyenTerme :</label>
                  <textarea formControlName="BackgroundButMoyenTerme" class="form-control"></textarea>
                </div>
                <div class="form-group col-4">
                  <label for="BackgroundButLongTerme">BackgroundButLongTerme :</label>
                  <textarea formControlName="BackgroundButLongTerme" class="form-control"></textarea>
                </div>
              </div>
              <input type="submit" value="Modifier" class="btn btnPrimary mt-3" >
            </form>    



            <h2>Compétences</h2>
            <div class="row pb-2" *ngFor="let competencePersonnage of personnage?.competences">
              <div class="col-5">
                <div>{{getCompetence(competencePersonnage.competenceId)?.nom}} - niveau {{competencePersonnage.niveau}}</div>
              </div>
              <div class="col">
                <button  (click)="removeCompetence(competencePersonnage)">Retirer</button>
              </div>
            </div>
          
            <form [formGroup]="addCompetenceForm" (ngSubmit)="addCompetence()">
              <div class="row">
                <div class="col-4 form-group">
                  <label for="addedCompetenceId">Compétence : </label>
                  <ng-select [items]="competences" bindLabel="nom" bindValue="id" formControlName="addedCompetenceId" />
                </div>
                <div class="col-1 form-group">
                  <label for="addedCompetenceNiveau">Niveau : </label>
                  <input type="text" formControlName="addedCompetenceNiveau" class="form-control">
                </div>   
                <div class="col pt-4">
                    <input type="submit" value="Ajouter compétence" class="btn btnPrimary" >
                </div>
              </div>  
            </form>


            <h2>Sorts</h2>
            <div class="row pb-2" *ngFor="let sort of getSortsPersonnage()">
              <div class="col-4">
                <div>{{sort.nom}}</div>
              </div>
              <div class="col">
                <button (click)="removeSort(sort)">Retirer</button>
              </div>
            </div>

            <form [formGroup]="addSortForm" (ngSubmit)="addSort()">
              <div class="row">
                <div class="col-4 form-group">
                  <label for="addedSortId">Sort : </label>
                  <ng-select [items]="sorts" bindLabel="nom" bindValue="id" formControlName="addedSortId" />
                </div>
                <div class="col pt-4">
                    <input type="submit" value="Ajouter sort" class="btn btnPrimary" >
                </div>
              </div>  
            </form>

            <hr />
            <h3><button (click)="deletePersonnage()">Supprimer la fiche de personnage</button></h3>
          </div>
        </div>
      </div>
    </div>
  </div>